import { useState } from 'react';
import { Button, TextField,  Grid, Box, Typography, Alert, FormControlLabel, Switch, } from '@mui/material';
import {  formToJson} from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
const EditClassroom = (props) => {
    const {data,onSubmit,onClose} = props
    const [fieldErrors, setFieldErrors] = useState()    
    const [error, setError] = useState()
    // const session = getUserSession(apis)
    const [hasTv,setTV] = useState(data?.has_tv)
    const [hasWb,setWhiteboard] = useState(data?.has_whiteboard)
    
    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const postData = formToJson(form)
        postData.id = data ? data.id:0
        postData.has_tv = hasTv
        postData.has_whiteboard = hasWb
        onSubmit && onSubmit(postData,setError,setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Role</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data?.name} name="name" required fullWidth id="name" label="Classroom Name"
                                error={fieldErrors && fieldErrors.name ? true : false}
                                helperText={fieldErrors && fieldErrors.name ? fieldErrors.name : ''}
                                autoFocus />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField type="number" min={0} defaultValue={data?.capacity} name="capacity" required fullWidth id="capacity" label="Classroom capacity"
                                error={fieldErrors && fieldErrors.capacity ? true : false}
                                helperText={fieldErrors && fieldErrors.capacity ? fieldErrors.capacity : ''}
                                autoFocus />
                        </Grid>
                       <Grid item xs={12} sm={6}>
                            <FormControlLabel control={<Switch defaultChecked={hasTv==1} />} label="Has TV?" onChange={(e)=>{setTV(e.target.checked?1:0)}}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel control={<Switch defaultChecked={hasWb==1}  />} label="Has Whiteboard" onChange={(e)=>{setWhiteboard(e.target.checked?1:0)}}/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField defaultValue={data?.description} multiline={true} name="note" fullWidth id="note" label="Note"
                                error={fieldErrors && fieldErrors.description ? true : false}
                                helperText={fieldErrors && fieldErrors.description ? fieldErrors.description : ''}
                                autoFocus />
                        </Grid>                               
                    </Grid>

                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { props.onClose && props.onClose(false) }}> Cancel </Button>
                </Box>
            </Box>
        </Container>
    );
}
export default EditClassroom